'use client';

import { useState } from 'react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { ApiLocation } from '../../services/api';
import { MapView, MapTheme } from '../map/types';

type SidebarProps = {
  data: ApiLocation;
  children: React.ReactNode;
  mapTheme: MapTheme;
  onMapThemeChange: (theme: MapTheme) => void;
  mapView: MapView;
  onMapViewChange: (view: MapView) => void;
};

export default function Sidebar({ data, children, mapTheme, onMapThemeChange, mapView, onMapViewChange }: SidebarProps) {
  const [isOpen, setIsOpen] = useState(true);
  const [activeTab, setActiveTab] = useState<'parameters' | 'analysis'>('parameters');

  return (
    <div className={`absolute right-0 top-0 h-full bg-white/60 backdrop-blur-sm shadow-lg transition-all duration-300 z-[1000] 
      ${isOpen ? 'w-96' : 'w-12'}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="absolute -left-4 top-4 bg-white/80 backdrop-blur-sm rounded-full p-1 shadow-md"
      >
        {isOpen ? (
          <ChevronRight className="h-6 w-6 text-gray-600" />
        ) : (
          <ChevronLeft className="h-6 w-6 text-gray-600" />
        )}
      </button>

      {isOpen && (
        <div className="h-full flex flex-col">
          <div className="p-6 pb-0">
            <div className="flex space-x-1 bg-gray-100/50 p-1 rounded-lg">
              <button
                onClick={() => setActiveTab('parameters')}
                className={`flex-1 py-2 px-4 rounded-md text-sm transition-colors
                  ${activeTab === 'parameters' 
                    ? 'bg-white text-[#005E6E] shadow-sm font-bold' 
                    : 'text-gray-500 hover:text-gray-700 font-medium'
                  }`}
              >
                Parameters
              </button>
              <button
                onClick={() => setActiveTab('analysis')}
                className={`flex-1 py-2 px-4 rounded-md text-sm transition-colors
                  ${activeTab === 'analysis' 
                    ? 'bg-white text-[#005E6E] shadow-sm font-bold' 
                    : 'text-gray-500 hover:text-gray-700 font-medium'
                  }`}
              >
                Real-Time Image
              </button>
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-6 pt-4">
            {activeTab === 'parameters' ? children : (
              <div>Analysis Tab Content</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
} 